import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { autocompleteClientRecruiter, IClientDTO } from 'wisestep-api';

import { getAutocompleteLabelForClientContactInJobs } from '../features/jobs/helper';

import WsFilterProps from './filters/models/WsFilterProps';
import { WsAsyncAutocomplete } from './WsAsyncAutocomplete';

interface IClientRecruiterFilterProps extends WsFilterProps {
  clients: IClientDTO[];
}

export const ClientRecruiterAutocomplete = ({
  name,
  multiple = false,
  placeHolder = 'Add by Name (or) Client/Company',
  clients,
}: IClientRecruiterFilterProps) => {
  const methods = useFormContext();

  const disabled = clients ? clients.length === 0 : true;

  useEffect(() => {
    if (disabled) {
      methods.setValue(name, []);
    }
  }, [clients, disabled, methods, name]);

  const getOptions = async (search: string) => {
    const clientIds = clients?.map((c) => c.id) as [];
    const result = await autocompleteClientRecruiter(search, clientIds);

    if (result?.data.length > 0) {
      const selected = methods.getValues(name) ?? [];
      return result.data
        .filter((contact) => !selected.some((selectedContact) => selectedContact.id === contact.id))
        .map((contact) => ({
          ...contact,
          label: getAutocompleteLabelForClientContactInJobs(contact),
        }));
    }
    return [];
  };

  return (
    <WsAsyncAutocomplete
      disabled={disabled}
      name={name}
      getOptions={getOptions}
      multiple={multiple}
      placeholder={disabled ? 'Please select a client' : placeHolder}
    />
  );
};
